import lodash from 'lodash-es';

(function (_) {
    /**
     * @typedef {Object} RewriteUrlRules
     * @property {boolean} [enabled] - Default: true
     * @property {string} [webroot] - Webroot condition, e.g: "/vc/bac"
     * @property {string} [method] - Method condition, e.g: "get"
     * @property {string[]} rewrite - [pattern, replace], e.g: ["^api_v3/rooms/([^\\.\\/])\\.json", "rooms/$1.json"]
     */

    /**
     * @typedef {Object} RewriteUrlConfig
     * @property {boolean} enabled - Default: true
     * @property {string} base_url - e.g: api-ms.vsee.io
     * @property {RewriteUrlRules[]} rules
     */


    function realpath(path) {
        const a = document.createElement('a');
        a.setAttribute('href', path);
        return new URL(a.href);
    }

    /**
     *
     * @param {RewriteUrlConfig} config
     */
    function formatConfig(config) {
        config.enabled = !!(config.enabled !== false && config.rules && config.rules.length);
        if (config.enabled) {
            config.rules = config.rules.filter(function (rule) {
                return rule.enabled !== false && rule.rewrite && rule.rewrite.length === 2;
            });
            if (!config.rules.length) {
                config.enabled = false;
            }
        }
    }

    function checkProperty(p1, p2) {
        if (typeof p1 === 'string' && typeof p2 === 'string') {
            return p1.toUpperCase() === p2.toUpperCase();
        }
        return true;
    }

    function resolveRules(config, pathObj, method, webroot) {
        let reg, url;
        reg = new RegExp('^' + (webroot ? webroot : '') + '/');
        const pathRelative = pathObj.pathname.replace(reg, '');
        for (let rule of config.rules) {
            if (!checkProperty(method, rule.method) || !checkProperty(webroot, rule.webroot)) {
                continue;
            }
            reg = new RegExp(rule.rewrite[0], 'i');
            if (reg.test(pathRelative)) {
                url = pathRelative.replace(reg, rule.rewrite[1]) + pathObj.search;
                if (url.indexOf('http') !== 0 && config.base_url) {
                    return pathObj.protocol + '//' + config.base_url + '/' + url;
                } else {
                    return url;
                }
            }
        }
        return false;
    }

    /**
     *
     * @property {RewriteUrlConfig} _config
     */
    class ApiUrl {
        /**
         *
         * @param {string} path e.g "/vc/bac/api_v3/rooms/abc.json"
         * @param {string} [method] e.g: "get"
         * @param {string} [webroot] window.webroot, e.g: "/vc/bac"
         * @return {string} e.g "https://api-ms.vsee.io/rooms/abc.json?a=b"
         */
        resolve(path, method, webroot) {
            //Append token to url
            if (_.get(window.CONFIG, 'Account.api.microservice.url_append_token_and_account_code', false)) {
                if (path.indexOf('?') === -1) {
                    path += '?';
                }
                if (window.user && window.user.token) {
                    path += '&X-ApiToken=' + window.user.token;
                }
            }

            if (!this._config || !this._config.enabled || typeof path !== 'string') {
                return path;
            }
            const pathObj = realpath(path);
            if (webroot === undefined) {
                webroot = _.get(window, 'webroot');
            }
            const newPath = resolveRules(this._config, pathObj, method, webroot);
            return newPath ? newPath : path;
        }

        /**
         *
         * @param {Object} config window.CONFIG
         */
        init(config) {
            this._config = _.merge({}, _.get(config, 'api_ms'), _.get(config, 'Account.api_ms'));
            formatConfig(this._config);
        }
    }
    window.ApiUrl = new ApiUrl();
})(lodash);
